import { render, staticRenderFns } from "./AccrualsDataIngestionPanel.vue?vue&type=template&id=98e1e388&scoped=true"
import script from "./AccrualsDataIngestionPanel.vue?vue&type=script&lang=js"
export * from "./AccrualsDataIngestionPanel.vue?vue&type=script&lang=js"
import style0 from "./AccrualsDataIngestionPanel.scss?vue&type=style&index=0&id=98e1e388&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e1e388",
  null
  
)

export default component.exports